export const calculateCosts = (stockArray, backlogArray) => {

    const stockCost = stockArray ? stockArray.reduce((acc, current) => acc + (current * 5), 0) : 0;
    const backlogCost = backlogArray ? backlogArray.reduce((acc, current) => acc + (current * 25), 0) : 0;
    
    return (stockCost + backlogCost);
}